import HotelBookingView from "./HotelBookingView";

export default HotelBookingView;
